import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
    Box,
    Typography,
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Button,
    Divider,
    Table,
    TableBody,
    Tab,
    Tabs,
    TableRow,
    TableCell,
    Modal,
    colors
} from '@material-ui/core';
import "./ReorderUnits.css";
import { Link } from 'react-router-dom';
import CloseIcon from '@material-ui/icons/Close';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import SaveIcon from '@material-ui/icons/Save';
import { reorder_units } from '../../../../api/API';

const useStyles = makeStyles(theme => ({
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        outline: 'none',
        boxShadow: theme.shadows[20],
        width: 700,
        maxHeight: '100%',
        overflowY: 'auto',
        maxWidth: '100%'
    },

    container: {
        marginTop: theme.spacing(3)
    },

    actions: {
        justifyContent: 'flex-end'
    },

    saveButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        }
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
}));

export default class ReorderUnits extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            units: props.units
        }
    }

    handleDirection(direction, index) {
        var new_units = [...this.state.units];

        if (direction == "up") {
            if (index > 0) {
                var temp = new_units[index - 1];
                new_units[index - 1] = new_units[index];
                new_units[index] = temp;
            }
        } else {
            if (index < new_units.length - 1) {
                var temp = new_units[index + 1];
                new_units[index + 1] = new_units[index];
                new_units[index] = temp;
            }
        }

        this.setState(prev_state => {
            return {
                ...prev_state,
                units: new_units
            }
        });
    }

    async handleSave(){
        var units = this.state.units;
        var data = [];
        for(var i = 0; i < units.length; i++){
            data.push({unit_id: units[i]['showroom_unit_id'], position: i});
        }

        let res = await reorder_units({
            units: JSON.stringify(data)});
        if(res){
            this.props.onClose();
        }
    }
    render() {
        return (
            <Modal
                open={true}
            >
                <Card
                    {...this.props}
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        outline: 'none',
                        width: 700,
                        maxHeight: '100%',
                        overflowY: 'auto',
                        maxWidth: '100%'
                    }}
                    className={clsx(this.props.classes.root, this.props.className)}
                >
                    <CardHeader title="Reorder Units"></CardHeader>
                    <Divider></Divider>
                    <form>
                        <CardContent>
                            {
                                this.state.units.map((unit, i) => (
                                    <div className="unit" style={{
                                        padding: "3px 5px",
                                        borderBottom: "1px solid #eaeaea",
                                        display: 'flex'
                                    }}>
                                        <div style={{
                                            flexGrow: 1,
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center"
                                        }}>
                                            <span >{unit.name}</span>
                                        </div>
                                        <div className="shifter" style={{
                                            marginLeft: 0
                                        }}>
                                            <div className="up" style={{

                                            }}
                                                onClick={() => {
                                                    this.handleDirection("up", i);
                                                }}
                                            ><KeyboardArrowUpIcon></KeyboardArrowUpIcon></div>
                                            <div
                                            onClick={()=>{
                                                this.handleDirection("down", i);
                                            }}
                                             className="down">
                                                <KeyboardArrowDownIcon></KeyboardArrowDownIcon>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </CardContent>
                        <CardActions style={{
                            justifyContent: "flex-end"
                        }} className={this.props.classes.actions}>
                            <Button
                                onClick={this.props.onClose}
                                variant="contained"
                                style={{
                                    backgroundColor: "black"
                                }}
                            >
                                <CloseIcon className={this.props.classes.leftIcon} />
                    Close
                    </Button>
                            <Button
                                className={this.props.classes.saveButton}
                                onClick={this.handleSave.bind(this)}
                                variant="contained"
                            >
                                <SaveIcon className={this.props.classes.leftIcon} />
                    Save
                    </Button>
                        </CardActions>
                    </form>
                </Card>
            </Modal >
        );
    }
}

